"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arbitraryAutoVector3 = exports.arbitrarySchematicPosition2D = exports.arbitraryCornerVector4 = exports.arbitraryVector3 = exports.arbitraryVector2 = void 0;
const tslib_1 = require("tslib");
const fc = tslib_1.__importStar(require("fast-check"));
exports.arbitraryVector2 = fc.record({
    x: fc.float(),
    y: fc.float(),
});
exports.arbitraryVector3 = fc.record({
    x: fc.float(),
    y: fc.float(),
    z: fc.float(),
});
exports.arbitraryCornerVector4 = fc.record({
    topLeft: fc.float(),
    topRight: fc.float(),
    bottomLeft: fc.float(),
    bottomRight: fc.float(),
});
exports.arbitrarySchematicPosition2D = fc.record({
    x: fc.float(),
    y: fc.float(),
});
exports.arbitraryAutoVector3 = fc.record({
    x: fc.float(),
    y: fc.float(),
    z: fc.float(),
});
//# sourceMappingURL=vector.js.map